import { PaymentStatus } from 'types/api/payments';

export enum PacketStatus {
	Unactivated = 'unactivated',
	Pending = 'pending',
	Active = 'active',
	Expired = 'expired',
	Canceled = 'canceled',
	Deleted = 'deleted',
	Expiring = 'expiring',
	Failed = 'failed'
}

export type UserSubscription = {
	id: number | null;
	subscriber_id: number | null;
	status: string;
	payment_status: string;
	billing_period_next_on: string;
	billing_period_start_on: string;
	billing_period_end_on: string;
	current_basic_product: CurrentProduct;
	pending_basic_product: CurrentProduct | null;
	current_additional_products: CurrentProduct[];
	deleted_additional_products: CurrentProduct[];
};

export type CurrentProduct = {
	id: number;
	product_uuid: string;
	price_id: number;
	price: number;
	name: string;
	status: PacketStatus;
	payment_status: PaymentStatus;
	packet_promotion?: PacketPromotion | null;
	expires_on: string;
};

type PacketPromotion = {
	packet_id: string;
	subscription_id: number;
	subscriber_id: number;
	promotion_id: number;
	billing_periods_used_count: number;
	status: string;
};
